import { Tag, TagVariant } from '@creditornot/cb-tag';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { CampaignStatus } from '../types';

type CampaignStatusTagProps = {
  status: CampaignStatus;
};

const CAMPAIGN_STATUS_TAG_VARIANTS: Record<CampaignStatus, TagVariant> = {
  running: 'lightGreen',
  scheduled: 'lightBlack',
  cancelled: 'lightRed',
  completed: 'lightBlue',
  stopped: 'lightOrange',
};

const CAMPAIGN_STATUS_TEXT: Record<CampaignStatus, string> = {
  running: 'campaigns.status.running',
  scheduled: 'campaigns.status.scheduled',
  cancelled: 'campaigns.status.cancelled',
  completed: 'campaigns.status.completed',
  stopped: 'campaigns.status.stopped',
};

const CampaignStatusTag = ({ status }: CampaignStatusTagProps) => (
  <Tag variant={CAMPAIGN_STATUS_TAG_VARIANTS[status]}>
    <FormattedMessage id={CAMPAIGN_STATUS_TEXT[status]} />
  </Tag>
);

export default CampaignStatusTag;
